import {jsx as _jsx} from "react/jsx-runtime";

import StarterKit from '@tiptap/starter-kit'
import {createContext, useContext} from 'react'






export const TipTapRenderContext = createContext(null)

export function useTipTapContext() {
  const ctx = useContext(TipTapRenderContext)
  if (!ctx) throw new Error('useTipTapContext must be used within a <TipTapProvider>')
  return ctx
}







export function TipTapProvider(props) {
  const defaultExtensions = props.extensions || [StarterKit]
  const generateHTML = (doc, extensions = defaultExtensions) => {
    return props.generateHTML(doc, extensions)
  }
  const generateJSON = (html, extensions = defaultExtensions) => {
    return props.generateJSON(html, extensions)
  }

  return (
    _jsx(TipTapRenderContext.Provider, { value: {generateHTML, generateJSON}, children: 
      props.children
    })
  )
}
